<template>
  <div>
    <report-list
      @load_report="load_report"
      @create_report="create_report"
      @reports_loaded="reports_loaded"
    />
    <report-composer
      :templates="templates"
      ref="report_composer"
      :projects="projects"
    />
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import ReportComposer from "./composer/NgineDashboardComposer";
import ReportList from "./NgineDashboardList";

export default {
  name: "NgineDashboardComposerIndex",
  components: { ReportComposer, ReportList },
  filters: filters,
  data() {
    return {
      templates: [],
      projects: []
    };
  },
  methods: {
    load_report(report) {
      this.$refs.report_composer.load_report(report);
    },
    create_report() {
      this.$refs.report_composer.create_report();
    },
    reports_loaded(groups) {
      this.projects = groups;
    }
  },
  created() {},
  mounted() {
    let vm = this;
    local_api(vm, "post", "/report_composer/do-get-templates")
      .then((templates) => {
        vm.templates = templates;
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  }
};
</script>
